/**
 * Trust card on sage band — ds/card/landing-highlight--on-strong (.pen).
 */
export function FearCard({ icon, title, description }) {
  return (
    <div className="flex flex-col gap-space-3 rounded-ds-lg border border-white/25 bg-white/12 p-space-6">
      {icon ? (
        <span className="flex h-10 w-10 items-center justify-center rounded-ds-md bg-sage-50/15 text-sage-50">
          {icon}
        </span>
      ) : null}
      <h3 className="font-display text-type-display-stat font-semibold text-sage-50">{title}</h3>
      <p className="type-body-sm leading-relaxed text-sage-200">{description}</p>
    </div>
  );
}
